import { makeStyles } from '@rbx/ui';

const useAppHeadingStyles = makeStyles()((theme) => ({
  root: {
    margin: theme.spacing(9 / 2, 0),
    [theme.breakpoints.up('XLarge')]: {
      margin: theme.spacing(6, 0),
    },
  },
}));

export default useAppHeadingStyles;
